import { DeductibleValue } from "Components/InsuranceDetailsCard/ProductDetailsTable/ProductDetailsLists/Deductible";
import { ProductOwner } from "Components/InsuranceDetailsCard/ProductDetailsTable/ProductDetailsLists/ProductOwner";
import { ProductDetail } from "Components/InsuranceDetailsCard/ProductDetailsTable/interface";
import { MopedProduct } from "Store/interfaces/products/checkout/riskProducts/vehicleProducts/MopedProduct";
import React from "react";

export const mopedDetailsList = (product: MopedProduct): ProductDetail[] => {
  return [
    {
      name: "deductible",
      value: (
        <DeductibleValue
          value={product.priceSpecifications.deductible.code ?? "??"}
        />
      ),
    },
    {
      name: "insuranceHolderIsMopedOwner",
      value: (
        <ProductOwner
          isOwner={product.insuranceHolderIsOwner}
          owner={product.owner}
        />
      ),
    },
    {
      name: "damageRecentYears",
      value: product.damageCountRecentYears ?? 0,
    },
    {
      name: "yearOfLastDamage",
      value: product.yearOfLastDamage,
      hidden: product.damageCountRecentYears === 0,
    },
  ];
};
